import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";
import { Result, mappingResultError } from '@digibricks/core';
import { HOMEWORK_ASSIGNMENT_REPOSITORY } from '../../core';
import { HOMEWORK_ASSIGNMENT_API } from '../data-sources';
import { AssignmentMapper } from './assignment.mapper';
export var HomeworkAssignmentRepository = /*#__PURE__*/function () {
  function HomeworkAssignmentRepository(homeworkAssignmentApi, assignmentMapper) {
    _classCallCheck(this, HomeworkAssignmentRepository);

    this.homeworkAssignmentApi = homeworkAssignmentApi;
    this.assignmentMapper = assignmentMapper;
  }

  _createClass(HomeworkAssignmentRepository, [{
    key: "create",
    value: function () {
      var _create = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(input) {
        var responseOrError, responseDto, createAssignmentResponseOrError;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.homeworkAssignmentApi.create(input);

              case 2:
                responseOrError = _context.sent;

                if (!responseOrError.isFailure) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return", mappingResultError(responseOrError));

              case 5:
                responseDto = responseOrError.getValue();
                createAssignmentResponseOrError = this.assignmentMapper.toDomain(responseDto);

                if (!createAssignmentResponseOrError.isFailure) {
                  _context.next = 9;
                  break;
                }

                return _context.abrupt("return", mappingResultError(createAssignmentResponseOrError));

              case 9:
                return _context.abrupt("return", Result.ok(createAssignmentResponseOrError.getValue()));

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function create(_x) {
        return _create.apply(this, arguments);
      }

      return create;
    }()
  }, {
    key: "publishScore",
    value: function () {
      var _publishScore = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(input) {
        var responseOrError, responseDto, updatedAssignmentResponseOrError;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.homeworkAssignmentApi.publishScore(input);

              case 2:
                responseOrError = _context2.sent;

                if (!responseOrError.isFailure) {
                  _context2.next = 5;
                  break;
                }

                return _context2.abrupt("return", mappingResultError(responseOrError));

              case 5:
                responseDto = responseOrError.getValue();
                updatedAssignmentResponseOrError = this.assignmentMapper.toDomain(responseDto);

                if (!updatedAssignmentResponseOrError.isFailure) {
                  _context2.next = 9;
                  break;
                }

                return _context2.abrupt("return", mappingResultError(updatedAssignmentResponseOrError));

              case 9:
                return _context2.abrupt("return", Result.ok(updatedAssignmentResponseOrError.getValue()));

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function publishScore(_x2) {
        return _publishScore.apply(this, arguments);
      }

      return publishScore;
    }()
  }]);

  return HomeworkAssignmentRepository;
}();
export var homeworkAssignmentRepositoryProvider = {
  provide: HOMEWORK_ASSIGNMENT_REPOSITORY,
  useFactory: function useFactory(homeworkAssignmentApi, mapper) {
    return new HomeworkAssignmentRepository(homeworkAssignmentApi, mapper);
  },
  inject: [HOMEWORK_ASSIGNMENT_API, AssignmentMapper]
};